export default function ZeemanSplittingVisual() {
  return <div>Zeeman Splitting works</div>;
}